import * as mathjs from 'mathjs';
import COORXY from './COORXY';
var CoordTrans = /** @class */ (function () {
    // tslint:disable-next-line:no-empty
    function CoordTrans() {
        this.xPI = 3.14159265358979324 * 3000.0 / 180.0;
        this.PI = 3.1415926535897932384626;
        this.a = 6378245.0;
        this.ee = 0.00669342162296594323;
    }
    CoordTrans.prototype.bd09togcj02 = function (bdlng1, bdlat1) {
        var coorxy = new COORXY();
        var bdlng = +bdlng1;
        var bdlat = +bdlat1;
        var x = bdlng - 0.0065;
        var y = bdlat - 0.006;
        var z = mathjs.sqrt(x * x + y * y) - 0.00002 * mathjs.sin(y * this.xPI);
        var theta = mathjs.atan2(y, x) - 0.000003 * mathjs.cos(x * this.xPI);
        var gglng = z * mathjs.cos(theta);
        var gglat = z * mathjs.sin(theta);
        coorxy.X = gglng;
        coorxy.Y = gglat;
        return coorxy;
    };
    CoordTrans.prototype.gcj02tobd09 = function (lng1, lat1) {
        var coorxy = new COORXY();
        var lat = +lat1;
        var lng = +lng1;
        var z = mathjs.sqrt(lng * lng + lat * lat) + 0.00002 * mathjs.sin(lat * this.xPI);
        var theta = mathjs.atan2(lat, lng) + 0.000003 * mathjs.cos(lng * this.xPI);
        var bdlng = z * mathjs.cos(theta) + 0.0065;
        var bdlat = z * mathjs.sin(theta) + 0.006;
        coorxy.X = bdlng;
        coorxy.Y = bdlat;
        return coorxy;
    };
    CoordTrans.prototype.wgs84togcj02 = function (lng1, lat1) {
        var lat = +lat1;
        var lng = +lng1;
        var coorxy = new COORXY();
        if (this.out_of_china(lng, lat)) {
            coorxy.X = lng;
            coorxy.Y = lat;
            return coorxy;
        }
        else {
            var dlat = this.transformlat(lng - 105.0, lat - 35.0);
            var dlng = this.transformlng(lng - 105.0, lat - 35.0);
            var radlat = lat / 180.0 * this.PI;
            var magic = mathjs.sin(radlat);
            magic = 1 - this.ee * magic * magic;
            var sqrtmagic = mathjs.sqrt(magic);
            dlat = (dlat * 180.0) / ((this.a * (1 - this.ee)) / (magic * sqrtmagic) * this.PI);
            dlng = (dlng * 180.0) / (this.a / sqrtmagic * mathjs.cos(radlat) * this.PI);
            var mglat = lat + dlat;
            var mglng = lng + dlng;
            coorxy.X = mglng;
            coorxy.Y = mglat;
            return coorxy;
        }
    };
    CoordTrans.prototype.gcj02towgs84 = function (lng1, lat1) {
        var lat = +lat1;
        var lng = +lng1;
        var coorxy = new COORXY();
        if (this.out_of_china(lng, lat)) {
            coorxy.X = lng;
            coorxy.Y = lat;
            return coorxy;
        }
        else {
            var dlat = this.transformlat(lng - 105.0, lat - 35.0);
            var dlng = this.transformlng(lng - 105.0, lat - 35.0);
            var radlat = lat / 180.0 * this.PI;
            var magic = mathjs.sin(radlat);
            magic = 1 - this.ee * magic * magic;
            var sqrtmagic = mathjs.sqrt(magic);
            dlat = (dlat * 180.0) / ((this.a * (1 - this.ee)) / (magic * sqrtmagic) * this.PI);
            dlng = (dlng * 180.0) / (this.a / sqrtmagic * mathjs.cos(radlat) * this.PI);
            var mglat = lat + dlat;
            var mglng = lng + dlng;
            coorxy.X = lng * 2 - mglng;
            coorxy.Y = lat * 2 - mglat;
            return coorxy;
        }
    };
    CoordTrans.prototype.transformlat = function (lng1, lat1) {
        var lat = +lat1;
        var lng = +lng1;
        var ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat
            + 0.2 * mathjs.sqrt(mathjs.abs(lng));
        ret += (20.0 * mathjs.sin(6.0 * lng * this.PI) + 20.0 * mathjs.sin(2.0 * lng * this.PI)) * 2.0 / 3.0;
        ret += (20.0 * mathjs.sin(lat * this.PI) + 40.0 * mathjs.sin(lat / 3.0 * this.PI)) * 2.0 / 3.0;
        ret += (160.0 * mathjs.sin(lat / 12.0 * this.PI) + 320 * mathjs.sin(lat * this.PI / 30.0)) * 2.0 / 3.0;
        return ret;
    };
    CoordTrans.prototype.transformlng = function (lng1, lat1) {
        var lat = +lat1;
        var lng = +lng1;
        var ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * mathjs.sqrt(mathjs.abs(lng));
        ret += (20.0 * mathjs.sin(6.0 * lng * this.PI) + 20.0 * mathjs.sin(2.0 * lng * this.PI)) * 2.0 / 3.0;
        ret += (20.0 * mathjs.sin(lng * this.PI) + 40.0 * mathjs.sin(lng / 3.0 * this.PI)) * 2.0 / 3.0;
        ret += (150.0 * mathjs.sin(lng / 12.0 * this.PI) + 300.0 * mathjs.sin(lng / 30.0 * this.PI)) * 2.0 / 3.0;
        return ret;
    };
    CoordTrans.prototype.out_of_china = function (lng1, lat1) {
        var lat = +lat1;
        var lng = +lng1;
        return !(lng > 73.66 && lng < 135.05 && lat > 3.86 && lat < 53.55);
    };
    return CoordTrans;
}());
export default CoordTrans;
